import E from '../ui_core/E';
import IconButtonNonReact from '../components/IconButtonNonReact';
import { faBackward, faTimes} from '@fortawesome/free-solid-svg-icons';
export default class ButtonFactory{
	static close(className, callback, disposes){
		const iconButtonNonReact = new IconButtonNonReact({faIcon:faTimes, onClick:callback, className});
		disposes.push(iconButtonNonReact.dispose);
		return iconButtonNonReact.element;
	}
}